import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import './auth.css';
import axios from 'axios';

export default function Login() {
  const navigate=useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formData,setFormData]=useState({
    email:'',
    password:''
  })

  const handlesubmit=async()=>{
    const response = await axios.post(`https://api.squareandangle.pranatigroup.in/api/authentication/authlogin`,{
      email:formData.email, password:formData.password
    });
    localStorage.setItem('user', JSON.stringify(response.data.user));
    localStorage.setItem('userId', response.data.user?.id ?? '');
    localStorage.setItem('role', response.data.user?.role ?? '');
    navigate('/admin/chat_ready');
  }

  return (
    <div className="authPage">
      <div className="authShell" aria-label="Login page">
        <div className="authCard">
          <div className="authCardInner">
            <div className="authBrand">
              <div className="authLogo" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
                </svg>
              </div>
              
                
                <p>Pranati </p>
              
            </div>

            <h2 className="authTitle">Welcome back</h2>
            <p className="authSubtitle">Sign in to continue to your admin dashboard.</p>

            <form className="authForm" s>
              <div>
                <label className="authLabel" htmlFor="login-email">Email Address</label>
                <div className="authField">
                  <Mail className="authIconLeft" size={18} />
                  <input
                    id="login-email"
                    className="authInput"
                    type="email"
                    
                    value={formData.email}
                    onChange={(e) => setFormData({...formData,email:e.target.value})}
                    placeholder="your.email@company.com"
                  />
                </div>
              </div>

              <div>
                <label className="authLabel" htmlFor="login-password">Password</label>
                <div className="authField">
                  <Lock className="authIconLeft" size={18} />
                  <input
                    id="login-password"
                    className="authInput"
                    type={showPassword ? 'text' : 'password'}
                   
                    value={formData.password}
                    onChange={(e)=>setFormData({...formData,password:e.target.value})}
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    className="authIconRightButton"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <div className="authRow">
                <label className="authCheck">
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label>
                <Link to="/forgot-password" className="authLink">
                  Forgot password?
                </Link>
              </div>

              <button type="button" className="authButton" onClick={handlesubmit}>
                Sign In
              </button>

              <div className="authDivider">or</div>

            

              <div className="authFooter">
                Don&apos;t have an account?{' '}
                <Link to="/Register" className="authLink">Create one</Link>
              </div>
            </form>
          </div>
        </div>

        <div className="authFinePrint">
          <div>Protected by enterprise-grade security</div>
          <div>© 2026 Pranati. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}
